export default {"src":"/_next/static/media/add_white.8bcec2ba.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};